import { DatePicker, Text } from "designSystem/index";
import React from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";

export default () => {
	const onChangeValue = (value: Date) => {
		console.log(`DatePicker: ${value}`);
	};

	return (
		<CssColumnGrid columns={3}>
			<Text semiBold text="no value" />
			<Text semiBold text="null value" />
			<Text semiBold text="current date" />
			<DatePicker onChange={onChangeValue} />
			<DatePicker onChange={onChangeValue} value={null} />
			<DatePicker onChange={onChangeValue} value={new Date()} />
		</CssColumnGrid>
	);
};